'use client';
import React, { startTransition } from 'react';
import { SessionContext } from '@benzinga/session-context';
import {
  ConnatixLiveStreamData,
  ConnatixLiveStreamResponse,
  getInitialLiveStream,
  isLivestreamInSchedule,
  LivestreamManager,
} from '@benzinga/livestream';

interface HookReturnValue {
  livestreamData: ConnatixLiveStreamData | undefined | null;
  assembleLivestream: () => Promise<ConnatixLiveStreamResponse>;
}

export const useConnatixLivestream = (): HookReturnValue => {
  const session = React.useContext(SessionContext);
  const updated = React.useRef<boolean>(false);
  const [livestreamData, setLivestreamData] = React.useState<ConnatixLiveStreamData | undefined | null>(
    getInitialLiveStream(session.getSession()),
  );

  const assembleLivestream = async (): Promise<ConnatixLiveStreamResponse> => {
    try {
      if (updated.current) {
        return {
          data: livestreamData,
          enabled: isLivestreamInSchedule(livestreamData?.schedule || []),
        };
      }

      updated.current = true;

      const livestreamManager = session.getManager(LivestreamManager);
      const response = await livestreamManager.getConnatixLivestream();

      if (response?.ok?.enabled) {
        if (isLivestreamInSchedule(response.ok.data?.schedule || [])) {
          startTransition(() => {
            setLivestreamData(response?.ok?.data);
          });

          return {
            data: null,
            enabled: true,
          };
        }
      }

      return {
        data: response?.ok?.data,
        enabled: false,
      };
    } catch (e) {
      console.log('LIVESTREAM ERROR:', e);
      return {
        data: null,
        enabled: false,
      };
    }
  };

  return { assembleLivestream, livestreamData };
};
